import type { Location as RouterLocation } from 'react-router';

export function logoutUrl({ redirectTo }: { redirectTo?: RouterLocation | Location } = {}): string {
	// currently, the logout path does not handle:
	// - query params conservation => page might be different after logging out
	// - domain change => logout in dev redirects to the proxified server...
	const path = !redirectTo ? '/' : redirectTo.pathname;
	return `/logout?redirect_to=${encodeURIComponent(path)}`;
}
